import i18n from './../../../shared/i18n';
import BaseModel from "../../../core/components/input-widget/BaseModel";

export default class AudienceModel extends BaseModel {
  uuid = null;
  name = null;
  subject = null;
  description = null;

  constructor(data = {}) {
    super();
    Object.assign(this, {...data});
  }

  rules = {
    name: 'required',
    subject: 'required',
  };

  attributeHints = {
  };

  attributeLabels = {
    name: i18n.t('Name'),
    subject: i18n.t('Subject'),
    description: i18n.t('Description'),
  };
}
